export default __webpack_public_path__ + "static/media/pictogramBeaconGuarantee48.740ee96d.svg";